import { useEffect, useState } from 'react';

/**
 * Hook to detect if Apple Pay is available and set up on the user's device.
 */
export default function useApplePayAvailable(): boolean {
  const [isAvailable, setIsAvailable] = useState<boolean>(false);

  useEffect(() => {
    if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
      setIsAvailable(true);
    } else {
      setIsAvailable(false);
    }
  }, []);

  return isAvailable;
}
